<template>
  <div class="container py-1">
    <div
      class="border-[10px] rounded-[1.8rem] flex items-center justify-center flex-col px-[2.1rem] py-[2.1rem] border-jm_orange bg-jm_dark_green max-w-[92%] sm:max-w-[97%] mx-auto"
    >
      <img
        :src="logo"
        alt="logo"
        class="w-[95px] mb-[1rem] mt-[0.15rem] slide mx-auto"
      />
      <div
        class="text-[24px] font-bold uppercase text-center whitespace-nowrap leading-[2.15rem] max-w-md text-jm_white"
      >
        {{ $t("age_check.message") }}
      </div>
      <div
        class="mt-[0.7rem] mb-[0.3rem] text-[16px] max-w-80 leading-[1.17rem] text-center text-jm_white whitespace-pre-line"
      >
        {{ $t("age_check.enter_birthday") }}
      </div>
      <div
        class="flex sm:flex-row items-center justify-center mt-6 gap-[0.66rem]"
      >
        <button
          @click="handleClick('yes')"
          type="button"
          class="px-[3rem] py-[0.45rem] text-[16px] sm:text-sm font-bold bg-jm_white rounded-[0.7rem] border border-gray-200 uppercase text-jm_dark_green"
        >
          {{ $t("age_check.confirm_button") }}
        </button>
        <button
          @click="handleClick('no')"
          type="button"
          class="px-[3rem] py-[0.45rem] text-[16px] sm:text-sm font-bold bg-jm_white rounded-[0.7rem] border border-gray-200 uppercase text-jm_dark_green"
        >
          {{ $t("age_check.reject_button") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";
import logo from "@/assets/images/misc/logo_jaegermeister_white.svg";

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();

const handleClick = async (answer: string) => {
  if (answer === "yes") {
    globalStore.confirmAgeCheck(true);
    kpiTracker.setConfirmedConsent(true);
    
    // Set progress to 1 (age_gate_clicked) when user clicks yes
    kpiTracker.setProgress(1);
    
    // Update session with progress "age_gate_clicked"
    console.log("[AgeSelector] Updating session with progress 'age_gate_clicked'");
    try {
      await session.updateSessionProgress(kpiTracker.getKpiData(), { step: "age_gate_clicked" });
      console.log("[AgeSelector] Session update completed");
    } catch (error) {
      console.error("[AgeSelector] Error updating session:", error);
    }

    globalStore.changeStep("termsAcceptance");
  } else {
    // For "no", don't track age_gate_clicked - just go to ageCheckFailed
    // The ageCheckFailed step will be tracked automatically by the watch in App.vue
    globalStore.changeStep("ageCheckFailed");
  }
};
</script>

<style scoped lang="sass">
@import "@/assets/sass/main.sass"
</style>
